import { SvgIcon } from "@material-ui/core";

export const Drawer = (props) => (
  <SvgIcon {...props} viewBox="2 0 24 24">
    <path d="M22.1818 4H5.81818C5.33597 4 4.87351 4.15325 4.53253 4.42603C4.19156 4.69881 4 5.06878 4 5.45455V18.5455C4 18.9312 4.19156 19.3012 4.53253 19.574C4.87351 19.8468 5.33597 20 5.81818 20H22.1818C22.664 20 23.1265 19.8468 23.4675 19.574C23.8084 19.3012 24 18.9312 24 18.5455V5.45455C24 5.06878 23.8084 4.69881 23.4675 4.42603C23.1265 4.15325 22.664 4 22.1818 4ZM5.81818 5.45455H11.2727V18.5455H5.81818V5.45455ZM22.1818 18.5455H13.0909V5.45455H22.1818V18.5455Z" fill="#2590FF"/>
  </SvgIcon>
)